<template>
  <div>
    <!-- 新增服务单 -->
    <el-dialog :title="$t('message.addServiceOrder')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1868px" center>
      <div class="content">
        <!-- 服务单号 -->
        <div class="head">
          <div class="service_sn">
            <div class="label">{{ $t('message.serviceOrderNumber') }}:</div>
            <div class="value">{{ detail.service_sn }}</div>
          </div>
          <div class=" row">
            <!-- 非检品工种创建 FBA 操作单时，只允许选择系统默认操作人规则。 -->
            <div class="value fba-operator-choice" v-if="isNonInspectionRole && isFbaService">
              <el-radio-group v-model="datas.fba_pre_operator">
                <el-radio :label="1">{{ $t('message.fbaPreOperatorLeader') }}</el-radio>
                <el-radio :label="2">{{ $t('message.fbaPreOperatorFba') }}</el-radio>
              </el-radio-group>
            </div>
            <!-- 检品工种及其他服务类型沿用原服务操作人选择。 -->
            <div class="value" v-else>
              <el-select v-model="datas.adminId" clearable :placeholder="$t('message.serviceOperator')" filterable>
                <el-option v-for="item in adminOptions" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- 要求完成时间 -->
            <div class="value">
              <el-date-picker v-model="datas.need_complete_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$t('message.requiredCompletionTime')">
              </el-date-picker>
            </div>
            <!-- 服务单类型 -->
            <div class="value">
            <el-select v-model="datas.cate_id" clearable :placeholder="$t('message.serviceOrderType')" filterable
              @change="handleCategoryChange">
                <el-option v-for="item in cateList" :key="item.cate_id" :label="item.cate_name" :value="item.cate_id">
                </el-option>
              </el-select>
            </div>
            <div class="oneClickOperation">
              <el-button type="primary" @click="clearAll">一键清空已添加服务</el-button>
              <el-button type="primary" class="primary"
                @click="addMachineService(['配套', '气泡膜', '更换定制包装'])">一键添加普通服务</el-button>
              <el-button type="primary" class="primary"
                @click="addMachineService(['塑封', '真空压缩'])">一键添加机器操作服务</el-button>
              <el-button type="primary" class="primary" @click="addMachineService(['摄影', '拍照'])">一键添加摄影操作服务</el-button>
              <!-- <el-button type="primary" class="primary" @click="addMachineService(['取布标', '缝布标'])">一键添加布标服务</el-button> -->
              <el-button type="primary" class="primary" @click="addMachineService(['FBA', '贴标'])">一键添加FBA服务</el-button>
            </div>
          </div>
          <!-- 服务操作人 -->
          <div class="quantityStatistics">
            <!--总计需要操作  -->
            <p>{{ $t("message.totalNeedToOperate") }}</p>
            <div class="total">
              <div class="item" v-for="(item, index) in total" :key="index">
                {{ item.name }}：
                <span>{{ item.should }}</span>
              </div>

            </div>
          </div>
        </div>

        <div class="table">
          <ol>
            <!-- 番号 -->
            <li class="flex05">
              <el-checkbox v-model="checked" @change="allCheckedChange">
              </el-checkbox>
            </li>
            <!-- 订单号 -->
            <li class="flex15">{{ $t("message.orderNumber") }}</li>
            <!-- 番号 -->
            <li class="flex05">
              {{ $t("message.mash") }}
            </li>
            <!-- 照片 -->
            <li>{{ $t("message.pic") }}</li>
            <!-- 业务编辑商品属性 -->
            <li class="flex2">
              {{ $t("message.theBusinessEditsTheCommodityProperties") }}
            </li>
            <!-- 购买信息 -->
            <li>{{ $t("message.purchaseInformation") }}</li>
            <!-- 附加服务 -->
            <li class="flex2">
              {{ $t("message.additionalServices") }}
            </li>
            <!-- 担当备注 -->
            <li class="flex15">
              {{ $t("message.responsibleForRemarks") }}
            </li>
            <!-- 核查员备注 -->
            <li class="flex15">
              {{ $t("message.verifierSNotes") }}
            </li>
            <!-- 操作内容-需要操作数量-可提交操作数量 -->
            <li class="flex3">
              操作内容-需要操作数量-可提交操作数量
            </li>
            <!-- 检品组长备注 -->
            <li>
              {{ $t("message.inspectionLeaderRemark") }}
            </li>
            <!-- 操作人员备注 -->
            <li>
              {{ $t("message.operationPersonnelRemark") }}
            </li>
          </ol>
          <ul v-for="(item, index) in detail.detail" :key="index">
            <li class="flex05">
              <el-checkbox v-model="item.checked" @change="checkedChange">
              </el-checkbox>
            </li>
            <!-- 订单号 -->
            <li class="flex15">
              <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn" target="_blank" class="a-link">
                {{ item.order_sn }}
              </router-link>
            </li>
            <!-- 番号 -->
            <li class="flex05">
              {{ item.sorting }}
            </li>
            <!-- 照片 -->
            <li>
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                <a href="JavaScript:;" slot="reference">
                  <el-image :src="item.pic" style="width: 60px; height: 60px; border-radius: 4px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
            </li>
            <!-- 业务编辑商品属性 -->
            <li class="flex2">
              <div class="template">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 购买信息 -->
            <li>
              <div class="template">
                <p>数量：{{ item.confirm_num }}
                </p>
                <p>单价：{{ item.confirm_price }}</p>
              </div>
            </li>
            <!-- 附加服务 -->
            <li class="flex2">
              <div class="template">
                <el-tooltip placement="bottom" style="max-height: 100px">
                  <div slot="content">
                    <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex"
                      style="margin-bottom: 3px">
                      <p>
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex">
                      <p>
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 担当备注 -->
            <li class="flex15">
              <p> {{ item.y_remark }}</p>
            </li>
            <!-- 核查员备注 -->
            <li class="flex15">
              <p> {{ item.p_remark }}</p>
            </li>
            <li class="flex3">
              <div class="template option">
                <div class="row" v-for="(extra, extraIndex) in item.extraOptions" :key="extraIndex">
                  <div class="label">{{ extra.name }}:</div>
                  <div class="input">
                    <el-input v-model="extra.should" placeholder="数量" @input="handleInput(extra)"></el-input>
                  </div>
                  <div class="num">{{ extra.should_total }}</div>
                  <div class="del"><i class="el-icon-error" @click="delExtra(index, extraIndex)"></i></div>
                </div>
                <!-- 添加服务 -->
                <el-button type="success" @click="addService(item, index)">添加服务</el-button>
              </div>
            </li>
            <!-- 检品组长备注，创建时随服务单数据一并提交。 -->
            <li>
              <el-input v-model="item.leader_remark" :placeholder="$t('message.inspectionLeaderRemark')"
                type="textarea"></el-input>
            </li>
            <!-- 操作人员备注，创建时随服务单数据一并提交。 -->
            <li>
              <el-input v-model="item.mechanic_remark" :placeholder="$t('message.operationPersonnelRemark')"
                type="textarea"></el-input>
            </li>

          </ul>
        </div>
        <div class="btn">
          <!-- 提交给检品 -->
          <el-button type="primary" @click="optionServiceStore(0)">
            {{ $t('message.submitToInspection') }}
          </el-button>
          <!-- 操作完了 -->
          <el-button type="success" @click="optionServiceStore(1)" v-if="isAuth(591) && !isNonInspectionRole">
            {{ $t('message.operationCompleted') }}
          </el-button>
        </div>
        <!-- 底部 -->
        <div class="footer">
          <!-- 注意事项-->
          <div class="label">
            {{ $t('message.mattersNeedingAttention') }}:
          </div>

          <div class="text">
            <el-input type="textarea" v-model="datas.remark"></el-input>
          </div>
          <!-- 服务单附件： -->
          <div class="label">
            {{ $t('message.serviceOrderAttachment') }}:
          </div>
          <div class="file">
            <div class="file-list">
              <a :href="item" target="_blank" rel="noopener noreferrer" v-for="(item, index) in datas.file" :key="index"
                :title="item">
                <i class="el-icon-folder-checked"></i>
              </a>
            </div>
            <el-upload :action="baseURL + '/api/common/uploadFile'" :show-file-list="false" :http-request="httpup" drag>
              <el-button slot="trigger" type="primary">
                上传文件
              </el-button>
            </el-upload>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 选项 当前番附加服务-->
    <singleOption ref="singleOption" />
  </div>
</template>
<script>
import singleOption from '@/components/common/option.vue'

const MECHANICAL_OPERATOR = {
  id: 1377,
  username: 'P209',
  realname: '机器操作员',
  forbid_login: 0
}

export default {
  props: {
    userRole: { type: [String, Number], default: '' },
  },
  components: {
    singleOption
  },
  computed: {
    // 机械服务额外显示机器操作员；接口已返回同一 ID 时不重复添加。
    adminOptions() {
      if (this.datas.cate_id != 2 || this.adminLis.some(item => item.id == MECHANICAL_OPERATOR.id)) {
        return this.adminLis
      }
      return [MECHANICAL_OPERATOR, ...this.adminLis]
    },
    isNonInspectionRole() {
      return String(this.userRole) !== '6'
    },
    isFbaService() {
      return String(this.datas.cate_id) === '5'
    }
  },
  data() {
    return {
      checked: false,//是否全选
      detail: {
        detail: []
      }, //服务单详情
      adminLis: [], //可选检品操作人员
      datas: {},//服务单详情
      total: [], //服务单详情-总数
      dialogVisible: false,
      cateList: [],
      addIndex: 0,
      fba_name: '',
    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.checked = false
        const date = new Date()
        //  要求完成时间默认2天后20:00 
        date.setDate(date.getDate() + 2)
        date.setHours(20, 0, 0)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        const seconds = String(date.getSeconds()).padStart(2, '0')
        const twoDaysLater = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`

        this.datas = {
          file: [],
          adminId: '',
          fba_pre_operator: 1,
          need_complete_at: twoDaysLater,
          cate_id: 1,
        }
        this.usableAdminList()
        this.$api.optionServiceApi.cateList().then(res => {
          this.cateList = res.data
        })
      }
    },
  },
  methods: {
    // 服务单-新增预览
    optionServicePreview(datas) {
      this.$api.optionServiceApi.optionServicePreview(datas).then(res => {
        res.data.detail.forEach(item => {
          item.checked = false
          item.extraOptions = []
          item.leader_remark = item.leader_remark || ''
          item.mechanic_remark = item.mechanic_remark || ''
          item.extra_options.forEach(extraItem => {
            extraItem.should_total = extraItem.should - 0
          })
        })
        this.detail = res.data
        this.datas.service_sn = res.data.service_sn
        this.datas.porder_sn = res.data.porder_sn

        this.calculateTotal()
      })
    },
    // 切换服务类型时，FBA 操作单默认选中检品组长规则。
    handleCategoryChange(value) {
      if (String(value) === '5') this.$set(this.datas, 'fba_pre_operator', 1)
    },
    //服务单-可选检品操作人员
    usableAdminList() {
      this.$api.optionServiceApi.usableAdminList().then(res => {
        this.adminLis = res.data
        let fba = res.data.find(item => item.realname == this.fba_name)
        if (fba) {
          this.datas.adminId = fba.id
          this.datas.cate_id = 5
        }
      })
    },
    // 计算总数
    calculateTotal() {
      this.total = []
      this.detail.detail.forEach(item => {
        item.extraOptions.forEach(extraItem => {
          let existingItem = this.total.find(totalItem => totalItem.name == extraItem.name)
          if (existingItem) {
            existingItem.should += extraItem.should - 0
          } else {
            this.total.push({
              name: extraItem.name,
              should: extraItem.should - 0
            })
          }
        })
      })
    },
    handleInput(item) {
      // 将输入值转换为数字，去除所有非数字字符
      let value = item.should.replace(/\D/g, '');
      // 如果输入为空，则清空
      if (value === '') {
        item.should = '';
      } else {
        // 转换为数字
        const number = parseInt(value, 10);
        // 确保是正整数
        if (isNaN(number) || number < 0) {
          item.should = '';
        } else {
          // 不能大于should值
          const maxShould = parseInt(item.should_total, 10) || 0;
          if (number > maxShould) {
            item.should = maxShould.toString();
          } else {
            item.should = number.toString();
          }
        }
      }
      this.$forceUpdate()
    },
    // 文件上传事件
    async httpup(file) {
      let data = await this.createClient(file)
      this.datas.file.push(data.data)
      this.$forceUpdate()
    },
    //新增服务单保存
    async optionServiceStore(type) {

      if (this.isNonInspectionRole && this.isFbaService) {
        if (!this.datas.fba_pre_operator) return this.$message.error('未选择服务操作人')
      } else if (this.datas.adminId == '') {
        return this.$message.error('未选择服务操作人')
      }
      if (this.datas.need_complete_at == null) return this.$message.error('未选择服务完成时间')
      if (this.datas.cate_id == '') return this.$message.error('未选择服务分类')
      this.datas.autoComplete = type
      // fba_pre_operator 只对订单详情非检品工种创建 FBA 操作单生效，其他服务单不带该字段。
      if (!(this.isNonInspectionRole && this.isFbaService)) delete this.datas.fba_pre_operator
      this.datas.serviceDetail = []
      this.detail.detail.forEach(item => {
        if (item.extraOptions.length != 0) {
          this.datas.serviceDetail.push({
            order_detail_id: item.id,
            leader_remark: item.leader_remark,
            mechanic_remark: item.mechanic_remark,
            extra_options: JSON.stringify(item.extraOptions)
          })
        }
      })
      if (this.datas.serviceDetail == false) return this.$message.error('提出的服务单数量不能全为0')
      const noOptionList = this.detail.detail.filter(item => item.extraOptions == false)
      try {
        if (noOptionList.length > 0) {
          const sortingText = noOptionList.map(item => item.sorting).filter(Boolean).join('、')
          await this.$confirm(
            `当前有 ${noOptionList.length} 番没有option，请确认无误后再生成。`,
            this.$t("message.hint"),
            {
              confirmButtonText: this.$t("message.ok"), //确定
              cancelButtonText: this.$t("message.cancel"), //取消
              type: "warning",
              center: true,
            }
          )
        }
        await this.$confirm(
          type == 0 ? '请确认服务单信息，数量无误后，再操作提出，提出后无法进行修改。' : '是否提出当前服务单，并直接完成服务单，操作后服务单无法取消，请确认后操作',
          this.$t("message.hint"),
          {
            confirmButtonText: this.$t("message.ok"), //确定
            cancelButtonText: this.$t("message.cancel"), //取消
            type: "warning",
            center: true,
          }
        )
      } catch (error) {
        return this.$message({
          type: "info",
          message: "已取消操作",
        });
      }
      this.$api.inspectionApi.optionServiceStore(this.datas).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$parent.checked = false;
      })

    },
    // 添加服务
    addService(item, index) {
      this.addIndex = index
      let option = JSON.parse(JSON.stringify(item.option))
      option.forEach(optionItem => {
        optionItem.checked = false
        item.extraOptions.forEach(extraItem => {
          if (extraItem.name == optionItem.name) {
            optionItem.checked = true
          }
        })
      })
      this.$refs.singleOption.optionsList = option.filter(item => item.name != '缝布标' || item.name != '取布标')
      this.$refs.singleOption.extra_options = item.extra_options
      this.$refs.singleOption.dialogVisible = true
    },
    // 保存额外选项
    saveOption(extraOptions) {
      this.detail.detail[this.addIndex].extraOptions = extraOptions
      this.calculateTotal()
      this.$forceUpdate()
    },
    // 删除额外选项
    delExtra(index, extraIndex) {
      this.detail.detail[index].extraOptions.splice(extraIndex, 1)
      this.calculateTotal()
      this.$forceUpdate()
    },
    // 一键清空已添加服务
    clearAll() {
      this.detail.detail.forEach(item => {
        if (item.checked) {
          item.extraOptions = []
        }
      })
      this.calculateTotal()
      this.$forceUpdate()
    },
    // 一键添加普通服务
    addNormalService() {
      let arr = ['取布标', '缝布标', '拍照', '摄影', '塑封', 'FBA', '贴标', '真空压缩']
      this.detail.detail.forEach(item => {
        if (item.checked) {
          item.extra_options.forEach(extraItem => {
            if (extraItem.should_total > 0) {
              const isArr = arr.some(arrItem => extraItem.name.indexOf(arrItem) != -1)
              // 去重：检查是否已存在相同name的服务
              const exists = item.extraOptions.some(existing => existing.name === extraItem.name)
              if (!exists && !isArr) {
                extraItem.should = extraItem.should_total
                item.extraOptions.push(extraItem)
              }
            }
          })
        }
      })
      this.calculateTotal()
      this.$forceUpdate()
    },
    // 一键添加操作服务
    addMachineService(arr) {
      this.detail.detail.forEach(item => {
        if (item.checked) {
          arr.forEach(arrItem => {
            item.extra_options.forEach(extraItem => {
              if (extraItem.should_total > 0) {
                // 使用indexOf判断extraItem.name是否包含在arr数组中
                if (extraItem.name.indexOf(arrItem) != -1) {
                  // 去重：检查是否已存在相同name的服务
                  const exists = item.extraOptions.some(existing => existing.name === extraItem.name)
                  if (!exists) {
                    extraItem.should = extraItem.should_total
                    item.extraOptions.push(extraItem)
                  }
                }
              }
            })
          })
        }
      })
      this.calculateTotal()
      this.$forceUpdate()
    },
    // 全选/取消全选
    allCheckedChange() {
      this.detail.detail.forEach(item => {
        item.checked = this.checked
      })
    },
    // 是否全选
    checkedChange() {
      this.checked = this.detail.detail.every(item => item.checked)
      this.$forceUpdate()
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  position: relative;

  .head {
    padding: 24px;
    background-color: #F6F6F6;
    margin-bottom: 24px;
    border-radius: 6px;
    font-size: 16px;
    color: #333333;

    .service_sn {
      display: flex;
      margin-bottom: 24px;
      display: flex;

      .value {
        color: #B4272D;
        margin-left: 10px;
      }
    }

    .row {
      display: flex;
      margin-bottom: 24px;
      line-height: 32px;
      position: relative;
      padding-bottom: 24px;
      border-bottom: 1px solid #DCDFE6;

      .oneClickOperation {
        position: absolute;
        top: 0px;
        right: 0px;
      }

    .value {
      width: 200px;
      margin-right: 12px;

        /deep/.el-select {
          width: 100%;
        }

        /deep/.el-date-editor {
          width: 100%;
        }
      }
    }

    .fba-operator-choice {
      width: 260px;
      line-height: 32px;
      white-space: nowrap;
    }

    .quantityStatistics {
      margin-top: 24px;

      p {
        margin-bottom: 6px;
      }

      .total {
        display: flex;
        flex-wrap: wrap;

        .item {
          margin-right: 36px;

          span {
            color: #B4272D;
          }
        }
      }
    }
  }


  .table {
    max-height: 600px;
    overflow: auto;
    position: relative;

    ol {
      display: flex;
      height: 50px;
      position: sticky;
      top: 0;
      left: 0;
      z-index: 99;

      li {
        text-align: center;
      }
    }

    ul {
      display: flex;
      padding: 20px 0;
      background-color: #fff;

      &:nth-last-child(1) {
        border-bottom: 0;
      }

      li {
        padding: 12px 3px;

        .template {
          width: 100%;
          overflow: hidden;

          .row {
            line-height: 20px;
            margin-bottom: 5px;
          }
        }
      }
    }

    li {


      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }

    .flex2 {
      flex: 2;
    }

    .flex3 {
      flex: 3.5;
    }

    .option {
      padding: 20px;
      border-radius: 6px;
      background-color: #F6F6F6;

      .row {
        display: flex;
        line-height: 40px !important;
        margin-bottom: 12px;

        .label {
          width: 100px;
        }

        .input {
          width: 80px;
          margin: 0 10px;
        }

        .num {
          width: 60px;
          margin-right: 10px;
          color: #2C96E7;
        }

        .del {
          width: 40px;
          font-size: 24px;

          i {
            color: #B4272D;
            cursor: pointer;
          }
        }
      }
    }
  }

  .btn {
    background-color: #F8F8F8;
    text-align: right;
    position: sticky;
    bottom: 0;
    left: 0;
    padding: 24px;
  }

  .footer {
    display: flex;
    margin-top: 24px;
    padding: 24px;
    background-color: #F8F8F8;

    .label {
      margin-right: 5px;
    }

    .text {
      width: 1000px;
      margin-right: 48px;

      /deep/.el-textarea__inner {
        height: 200px;
      }
    }

    .file {
      flex: 1;
      display: flex;

      /deep/.el-upload-dragger {
        width: 100px;
        height: 40px;
      }

      .file-list {
        i {
          font-size: 100px;
          margin-right: 20px;
          color: #b4272d;
        }
      }
    }
  }


  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}
</style>
